import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgFlightWithMoon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="#000"
    {...props}
  >
    <path
      d="M4.273 10a5 5 0 0 1 4.761-8.226 3.15 3.15 0 1 0 3.859 3.858 5.022 5.022 0 0 1 .083 1.53"
      strokeLinejoin="round"
    />
    <path d="M7.694 11.49 5.79 12.66s-.505.393-1.458.196c-.954-.196-1.931-.412-1.931-.412s-.21-.077-.354.11c-.145.188.093.3.093.3l1.47 1.065s.314.31.775.229c.462-.082 1.82-.357 1.82-.357s.927-.198 2.03-.886c1.101-.688 5.041-3.08 5.041-3.08s1.534-.872 1.38-1.237c-.154-.365-1.038-.267-1.46-.133-.423.133-3.722 2.004-3.722 2.004l-3.616-1.24s-.468-.111-.234.162 2.525 2.554 2.525 2.554M9.045 13.232l.983.98s.285.226.342-.561c.058-.787.116-1.376.116-1.376" />
  </svg>
);
const Memo = memo(SvgFlightWithMoon);
export default Memo;
